import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { reactive } from 'vue';
import { errorHandle as errorHandleText, errorTypes } from '@/views/spc/spcUtils';
export default {
  __name: 'SPCErrorPop',
  props: {
    errorHandleFn: {
      type: Object,
      default: () => {}
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    var props = __props;
    var errorPop = reactive({
      show: false,
      title: '',
      btnConfirmText: '',
      content: '',
      handelClose: () => {
        errorPop.title = '';
        errorPop.btnConfirmText = '';
        errorPop.content = '';
      },
      handelConfirm: null
    });
    var errorfn = (type = errorTypes.UNKNOWN_FAIL, title = '', content = '') => {
      var _errorHandleText$type, _errorHandleText$type2, _errorHandleText$type3, _errorHandleText$type4, _props$errorHandleFn$, _props$errorHandleFn, _props$errorHandleFn2;
      errorPop.title = !title ? (_errorHandleText$type = errorHandleText[type]) === null || _errorHandleText$type === void 0 ? void 0 : _errorHandleText$type.popTitle : title !== null && title !== void 0 ? title : '';
      errorPop.btnConfirmText = (_errorHandleText$type2 = (_errorHandleText$type3 = errorHandleText[type]) === null || _errorHandleText$type3 === void 0 ? void 0 : _errorHandleText$type3.popBtn) !== null && _errorHandleText$type2 !== void 0 ? _errorHandleText$type2 : '';
      errorPop.content = !content ? (_errorHandleText$type4 = errorHandleText[type]) === null || _errorHandleText$type4 === void 0 ? void 0 : _errorHandleText$type4.popContent : content !== null && content !== void 0 ? content : '';
      errorPop.handelConfirm = (_props$errorHandleFn$ = (_props$errorHandleFn = props.errorHandleFn) === null || _props$errorHandleFn === void 0 ? void 0 : _props$errorHandleFn[type]) !== null && _props$errorHandleFn$ !== void 0 ? _props$errorHandleFn$ : null;
      if ((_props$errorHandleFn2 = props.errorHandleFn) !== null && _props$errorHandleFn2 !== void 0 && _props$errorHandleFn2[type]) {
        errorPop.handelClose = () => {
          var _props$errorHandleFn3;
          (_props$errorHandleFn3 = props.errorHandleFn) === null || _props$errorHandleFn3 === void 0 ? void 0 : _props$errorHandleFn3[type]();
          errorPop.title = '';
          errorPop.btnConfirmText = '';
          errorPop.content = '';
        };
      }
      errorPop.show = true;
    };
    __expose({
      errorfn
    });
    return (_ctx, _cache) => {
      var _component_pop_up = _resolveComponent("pop-up");
      return _openBlock(), _createBlock(_component_pop_up, {
        show: errorPop.show,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => errorPop.show = $event),
        title: errorPop.title,
        content: errorPop.content,
        "btn-confirm-text": errorPop.btnConfirmText,
        onClose: errorPop.handelClose,
        onConfirm: errorPop.handelConfirm
      }, null, 8, ["show", "title", "content", "btn-confirm-text", "onClose", "onConfirm"]);
    };
  }
};